import { Component, Input } from '@angular/core'
import { GeneralService } from 'src/app/services/general/general.service'
import { LocaleService } from 'src/app/services/locale/locale-service'
import { LogService } from 'src/app/services/log/log.service'
import { UserService } from 'src/app/services/user/user.service'
import { BlockedCoupangAd } from '../blocked-coupang-ad/blocked-coupang-ad'
import { ModalService } from 'src/app/services/modal/modal.service'

@Component({
  selector: 'app-content-blocked-coupang-ad',
  templateUrl: './content-blocked-coupang-ad.component.html',
  styleUrls: ['./content-blocked-coupang-ad.component.scss'],
})
export class ContentBlockedCoupangAdComponent extends BlockedCoupangAd {
  constructor(
    protected generalService: GeneralService,
    protected logService: LogService,
    protected localeService: LocaleService,
    protected userService: UserService,
    protected modalService: ModalService
  ) {
    super(generalService, logService, localeService, userService, modalService)
  }

  @Input() title = `쿠팡을 방문하고 나면<br />모든 결과를 확인할 수 있어요`
  @Input() buttonTitle = '쿠팡 방문하고 결과 확인하기'
}
